import AbacusClientUtils from '@homeaway/abacus-client-utils';
import {HA_PULSE_SHARED_TRIPBOARD_AB_TEST} from '../abacus/experiments';
import edap, {GENERIC_EVENT} from '../utils/edap';
export const CATEGORY = 'tripboards';

// generic event utility methods
export function getBoardIdListingId(boardId, listingId) {
    if (typeof listingId !== 'undefined') {
        return `bid=${boardId};lid=${listingId}`;
    }
    return `bid=${boardId}`;
}

export function getDatesLabel(startDate, endDate) {
    const end = endDate || 'none';
    const start = startDate || 'none';
    return `startDate=${start};endDate=${end}`;
}

function boardEventTrigger(eventaction) {
    return (boardId) => {
        const data = {
            eventcategory: CATEGORY,
            eventaction,
            eventlabel: getBoardIdListingId(boardId)
        };
        edap.trigger(GENERIC_EVENT, data);
    };
}

// generic events
export const generic = {
    TRIP_BOARDS_ACTIVITY_SEEN: 'board.activity.seen',
    TRIP_BOARDS_ACTIVITY_INDICATOR: 'board.activity.indicator',
    TRIP_BOARDS_ACTIVITY_INDICATOR_TOOLTIP: 'board.activity.indicator.tooltip',
    TRIP_BOARDS_BOARD_DELETE_START: 'board.delete.start',
    TRIP_BOARDS_BOARD_DELETE_CANCEL: 'board.delete.cancel',
    TRIP_BOARDS_BOARD_DELETE_ATTEMPT: 'board.delete.attempt',
    TRIP_BOARDS_BOARD_EDIT_START: 'board.edit.start',
    TRIP_BOARDS_BOARD_EDIT_CANCEL: 'board.edit.cancel',
    TRIP_BOARDS_BOARD_EDIT_NAME: 'board.edit.name.attempt',
    TRIP_BOARDS_BOARD_EDIT_DONE: 'board.edit.done',
    TRIP_BOARDS_COMMENT_CLICK: 'board.comment.click',
    TRIP_BOARDS_COMMENT_ADD: 'board.comment.add',
    TRIP_BOARDS_COMMENT_VIEW_PROPERTY: 'board.comment.view.property',
    TRIP_BOARDS_LISTING_CLICK: 'listing.click',
    TRIP_BOARDS_LISTING_DELETE: 'listing.delete.attempt',
    TRIP_BOARDS_LOGIN: 'board.login.clicked',
    TRIP_BOARDS_SIGNUP: 'board.signup.clicked',
    TRIP_BOARDS_MAP_MARKER_CLICKED: 'board.map.marker.clicked',
    TRIP_BOARDS_MAP_PROPERTY_CLICKED: 'board.map.property.clicked',
    TRIP_BOARDS_MAP_TAB_CLICKED: 'board.map.tab.clicked',
    TRIP_BOARDS_MAP_INTERACTION: 'board.map.interaction',
    TRIP_BOARDS_SUMMARIES_LOAD: 'board.summary.load',
    TRIP_BOARDS_SUMMARIES_CLICK: 'boards.summary.click',
    TRIP_BOARDS_DETAILS_LOAD: 'board.details.load',
    TRIP_BOARDS_COLLABORATE_CLICK: 'boards.collaborate.click',
    TRIP_BOARDS_COPY_CLICK: 'boards.copy.click',
    TRIP_BOARDS_CAROUSEL_HIT_ARROW_CLICK: 'boards.carousel.hit.arrow.click',
    TRIP_BOARDS_CAROUSEL_COMMENTS_ARROW_CLICK: 'boards.carousel.comments.arrow.click',
    TRIP_BOARDS_CAROUSEL_HIT_CLICK: 'boards.carousel.hit.image.click',
    TRIP_BOARDS_SHARE_CLICK: 'boards.share.click',
    TRIP_BOARDS_COPY_URL: 'boards.url.copy',
    TRIP_BOARDS_CUT_URL: 'boards.url.cut',
    TRIP_BOARDS_DATES_CLICK: 'boards.dates.click',
    TRIP_BOARDS_DATES_CHANGE: 'boards.dates.change',
    TRIP_BOARDS_GUESTS_CLICK: 'boards.guests.click',
    TRIP_BOARDS_GUESTS_CHANGE: 'boards.guests.change',
    TRIP_BOARDS_INVITE_ACCEPT: 'board.invite.accept',
    TRIP_BOARDS_INVITE_INVALID: 'board.invite.invalid',
    TRIP_BOARDS_INVITE_INVALID_POP: 'board.invite.invalid.pop',
    TRIP_BOARDS_INVITE_INVALID_CLOSE: 'board.invite.invalid.close',
    TRIP_BOARDS_INVITE_EXPIRED_POP: 'board.invite.expired.pop',
    TRIP_BOARDS_INVITE_EXPIRED_CLOSE: 'board.invite.expired.close',
    TRIP_BOARDS_INVITE_EXPIRED_VIEW_TRIPBOARD_CLICK: 'board.invite.expired.view.tripboard.click',
    TRIP_BOARDS_INVITE_MODAL_POP: 'board.invite.modal.pop',
    TRIP_BOARDS_INVITE_MODAL_CLOSE: 'board.invite.modal.close',
    TRIP_BOARDS_INVITE_MODAL_LOGIN: 'board.invite.modal.login',
    TRIP_BOARDS_VOTES_VOTE_UP: 'board.votes.voteUp',
    TRIP_BOARDS_VOTES_VOTE_DOWN: 'board.votes.voteDown',
    TRIP_BOARDS_VOTES_VOTERS_CLOSE: 'board.votes.voters.close',
    TRIP_BOARDS_VOTES_VOTERS_OPEN: 'board.votes.voters.open',
    TRIP_BOARDS_PLACES_EMPTY: 'board.search.data.error',
    TRIP_BOARDS_LISTING_DELETE_MODAL_OPEN: 'board.listing.delete.modal.open',
    TRIP_BOARDS_LISTING_DELETE_MODAL_CLOSE: 'board.listing.delete.modal.close',
    BOARD_CREATE_ATTEMPT: 'board.create.attempt',
    BOARD_CREATE_CLICK: 'board.create.click',
    BOARD_SAVED: 'board.saved',
    BOARD_CREATE_ERROR: 'board.create.error',
    BOARD_CREATE_SKIP: 'board.create.skip',
    TRIP_BOARDS_CREATE_CONTROL_CLICK: 'board.create.control.click',
    TRIP_BOARDS_CREATE_MODAL_SEEN: 'board.create.control.modal.view',
    TRIP_BOARDS_CREATE_MODAL_CLOSED: 'board.create.control.modal.closed',
    TRIP_BOARDS_CREATE_MODAL_ERRORED: 'board.create.control.modal.error',
    TRIP_BOARDS_LEARNMORE_CLICK: 'board.login.learnmore.click'
};

// generic event methods
generic.activityIndicator = boardEventTrigger(generic.TRIP_BOARDS_ACTIVITY_INDICATOR);
generic.activityIndicatorTooltip = boardEventTrigger(generic.TRIP_BOARDS_ACTIVITY_INDICATOR_TOOLTIP);
generic.activitySeen = boardEventTrigger(generic.TRIP_BOARDS_ACTIVITY_SEEN);
generic.deleteStart = boardEventTrigger(generic.TRIP_BOARDS_BOARD_DELETE_START);
generic.deleteCancel = boardEventTrigger(generic.TRIP_BOARDS_BOARD_DELETE_CANCEL);
generic.deleteAttempt = boardEventTrigger(generic.TRIP_BOARDS_BOARD_DELETE_ATTEMPT);
generic.editStart = boardEventTrigger(generic.TRIP_BOARDS_BOARD_EDIT_START);
generic.editCancel = boardEventTrigger(generic.TRIP_BOARDS_BOARD_EDIT_CANCEL);
generic.editDone = boardEventTrigger(generic.TRIP_BOARDS_BOARD_EDIT_DONE);

generic.boardClick = function boardClick(boardId, position, total) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_SUMMARIES_CLICK,
        eventlabel: `${edap.getPositionLabel(position, total)};${getBoardIdListingId(boardId)}`
    });
};

generic.editAttempt = function editAttempt(boardId, from, to) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_BOARD_EDIT_NAME,
        eventlabel: `from=${from};to=${to};${getBoardIdListingId(boardId)}`
    });
};

generic.listingClick = function listingClick(boardId, listingId, position, total) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_LISTING_CLICK,
        eventlabel: `${edap.getPositionLabel(position, total)};${getBoardIdListingId(boardId, listingId)}`
    });
};

generic.listingDelete = function listingDelete(boardId, listingId, position, total) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_LISTING_DELETE,
        eventlabel: `${edap.getPositionLabel(position, total)};${getBoardIdListingId(boardId, listingId)}`
    });
};

generic.listingDeleteModalOpen = function listingDeleteModalOpen(boardId, listingId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_LISTING_DELETE_MODAL_OPEN,
        eventlabel: `${getBoardIdListingId(boardId, listingId)}`
    });
};

generic.listingDeleteModalClose = function listingDeleteModalClose(boardId, listingId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_LISTING_DELETE_MODAL_CLOSE,
        eventlabel: `${getBoardIdListingId(boardId, listingId)}`
    });
};

generic.placesError = (boardId) => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_PLACES_EMPTY,
        eventlabel: `${getBoardIdListingId(boardId)}`
    });
};

generic.detailsLoad = function detailsLoad(boardId, endDate, total, startDate) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_DETAILS_LOAD,
        eventlabel: `${edap.getTotal(total)};${getBoardIdListingId(boardId)};${getDatesLabel(startDate, endDate)}`
    });
};

generic.summariesLoad = function summariesLoad(total) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_SUMMARIES_LOAD,
        eventlabel: edap.getTotal(total)
    });
};

generic.carouselHitArrowClick = function carouselHitArrowClick(direction) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_CAROUSEL_HIT_ARROW_CLICK,
        eventlabel: direction
    });
};

generic.carouselHitClick = function carouselHitClick(position, total) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_CAROUSEL_HIT_CLICK,
        eventlabel: edap.getPositionLabel(position, total)
    });
};

generic.carouselCommentsArrowClick = function carouselCommentsArrowClick(direction) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_CAROUSEL_COMMENTS_ARROW_CLICK,
        eventlabel: direction
    });
};

generic.copyClick = function copyClick(boardId, endDate, startDate) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_COPY_CLICK,
        eventlabel: `${getBoardIdListingId(boardId)};${getDatesLabel(startDate, endDate)}`
    });
};

generic.shareClick = function shareClick(boardId, endDate, startDate) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_SHARE_CLICK,
        eventlabel: `${getBoardIdListingId(boardId)};${getDatesLabel(startDate, endDate)}`
    });
};

generic.copyUrl = function copyUrl(boardId, endDate, startDate) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_COPY_URL,
        eventlabel: `${getBoardIdListingId(boardId)};${getDatesLabel(startDate, endDate)}`
    });
};

generic.cutUrl = function cutUrl(boardId, endDate, startDate) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_CUT_URL,
        eventlabel: `${getBoardIdListingId(boardId)};${getDatesLabel(startDate, endDate)}`
    });
};

generic.datesClick = function datesClick(boardId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_DATES_CLICK,
        eventlabel: getBoardIdListingId(boardId)
    });
};

generic.datesChange = function datesChange(boardId, startDate, endDate) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_DATES_CHANGE,
        eventlabel: `${getDatesLabel(startDate, endDate)};${getBoardIdListingId(boardId)}`
    });
};

generic.guestsClick = function guestsClick(boardId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_GUESTS_CLICK,
        eventlabel: getBoardIdListingId(boardId)
    });
};

generic.guestsChange = function guestsChange(boardId, adultsCount, childrenCount, petsIncluded) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_GUESTS_CHANGE,
        eventlabel: `adultsCount=${adultsCount};childrenCount=${childrenCount};petsIncluded=${petsIncluded};${getBoardIdListingId(
            boardId
        )}`
    });
};

generic.mapInteraction = function mapInteraction(boardId, interaction) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_MAP_INTERACTION,
        eventlabel: `${getBoardIdListingId(boardId)};interaction=${interaction}`
    });
};

generic.mapMarkerClicked = function mapMarkerClicked(boardId, listingId) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_MAP_MARKER_CLICKED,
        eventlabel: `${getBoardIdListingId(boardId, listingId)}`
    });
};

generic.mapPropertyClicked = function mapPropertyClicked(boardId, index, total, listingId) {
    const edapIndex = index || '1';
    const edapTotal = total || '1';
    edap.trigger(
        GENERIC_EVENT,
        {
            eventcategory: CATEGORY,
            eventaction: generic.TRIP_BOARDS_MAP_PROPERTY_CLICKED,
            eventlabel: `${getBoardIdListingId(boardId, listingId)};position=${edapIndex};total=${edapTotal}`
        },
        {
            delayProcessing: true
        }
    );
};

generic.mapTabClicked = function mapTabClicked(boardId, mapTestValue, index) {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_MAP_TAB_CLICKED,
        eventlabel: `${getBoardIdListingId(boardId)}; testValue=${mapTestValue}; index=${index}`
    });
};

generic.viewProperty = (boardId, endDate, listingId, startDate, index, total) => {
    const edapIndex = index || '1';
    const edapTotal = total || '1';
    edap.trigger(
        GENERIC_EVENT,
        {
            eventaction: generic.TRIP_BOARDS_COMMENT_VIEW_PROPERTY,
            eventcategory: CATEGORY,
            eventlabel: `${getBoardIdListingId(boardId, listingId)};${getDatesLabel(
                startDate,
                endDate
            )};position=${edapIndex};total=${edapTotal}`
        },
        {delayProcessing: true}
    );
};

generic.tripboardLogin = () => {
    edap.trigger(
        GENERIC_EVENT,
        {
            eventaction: generic.TRIP_BOARDS_LOGIN,
            eventcategory: CATEGORY
        },
        {delayProcessing: true}
    );
};

generic.tripboardSignup = () => {
    edap.trigger(
        GENERIC_EVENT,
        {
            eventaction: generic.TRIP_BOARDS_SIGNUP,
            eventcategory: CATEGORY
        },
        {delayProcessing: true}
    );
};

generic.boardCreate = (boardName, listingId) => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.BOARD_CREATE_ATTEMPT,
        eventlabel: `name=${boardName}; lid=${listingId}`
    });
};

generic.learnMoreClick = () => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_LEARNMORE_CLICK
    });
};

generic.boardSaved = (boardId, listingId) => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.BOARD_SAVED,
        eventlabel: `isnewboard=1; lid=${listingId}; bid=${boardId}`
    });
};

generic.boardCreateClick = (listingId) => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.BOARD_CREATE_CLICK,
        eventlabel: `lid=${listingId}`
    });
};

generic.boardCreateError = (listingId) => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.BOARD_CREATE_ERROR,
        eventlabel: `lid=${listingId}`
    });
};

generic.boardCreateSkip = () => {
    edap.trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.BOARD_CREATE_SKIP
    });
};

/** @name accesstype edap enum (edap-integrations@8.6.0) */
export const ACCESS_TYPE = {
    OWNER: 'admin',
    COLLABORATOR: 'collaborator',
    VIEWER: 'viewer'
};

/** @name entitytype edap enum (edap-integrations@8.6.0) */
export const ENTITY_TYPE = {
    BOARD: 'trip board', // @entityvalue: '<trip board uuid>' '3635e571-a3f9-4af6-a252-6019b78e2992'
    LISTING: 'unit', // @entityvlaue: '<listingid>' '321.21011.21011'
    DATE: 'date', // @entityvlaue: '<date>' '2014-04-20'
    GUESTS: 'guests', // @entityvalue: '<guest count>' '2'
    CHILDREN: 'children', // @entityvalue: '<child count>' '0'
    PETS: 'pets', // @entityvalue: '<pets count>' '0'
    ROLE: 'role' // @entityvalue: '<role>' 'collaborator'
};

// lookup table to validate entitytype values above
let ENTITY_TYPE_MAP = {};
Object.values(ENTITY_TYPE).forEach((val) => {
    ENTITY_TYPE_MAP[val] = true;
});

// named event utility methods
export function getAccessType(role = '') {
    return ACCESS_TYPE[role.toUpperCase()] || ACCESS_TYPE.VIEWER;
}

export function isValidEntityType(type) {
    return type in ENTITY_TYPE_MAP;
}

export function isValidEntityArgs(boardid, entitytype) {
    return boardid && isValidEntityType(entitytype);
}

export function tripboardEntityAction(namedEvent, needsAccessType) {
    return function(boardid, entitytype, entityvalue, role) {
        const accesstype = role ? getAccessType(role) : null;
        if (!isValidEntityArgs(boardid, entitytype) || (needsAccessType && !role)) {
            return;
        }

        if (accesstype) {
            edap.trigger(namedEvent, {
                boardid,
                entitytype,
                entityvalue,
                accesstype
            });
            return;
        }

        edap.trigger(namedEvent, {
            boardid,
            entitytype,
            entityvalue
        });
    };
}

// named events (edap-integrations@9.10.0)
export const named = {
    TRIP_BOARD_CLICK: 'tripboards.click',
    TRIP_BOARD_DELETE: 'tripboards.delete',
    TRIP_BOARD_REMOVE: 'tripboards.remove',
    TRIP_BOARD_UPDATE: 'tripboards.update',
    TRIP_BOARD_VIEW: 'tripboards.view',
    TRIP_BOARD_SEARCH_DATED: 'dated.search.submit',
    TRIP_BOARD_SEARCH: 'search.submit',
    HEARTING_CLICK: 'hearting.click',
    TRIP_BOARD_CREATE: 'tripboards.create'
};

// named event methods
named.click = tripboardEntityAction(named.TRIP_BOARD_CLICK);
named.remove = tripboardEntityAction(named.TRIP_BOARD_REMOVE, true);
named.update = tripboardEntityAction(named.TRIP_BOARD_UPDATE, true);

named.create = function tripboardCreate(boardid) {
    if (!boardid) {
        return;
    }
    edap.trigger(named.TRIP_BOARD_CREATE, {boardid});
};

named.delete = function tripboardDelete(boardid) {
    if (!boardid) {
        return;
    }
    edap.trigger(named.TRIP_BOARD_DELETE, {boardid});
};

named.view = function tripboardView(boardid, role) {
    if (!boardid) {
        return;
    }
    edap.trigger(named.TRIP_BOARD_VIEW, {
        accesstype: getAccessType(role),
        boardid
    });
};

named.search = function tripboardSearch(boardid, role, dated, type) {
    if (!boardid) {
        return;
    }
    if (dated) {
        edap.trigger(named.TRIP_BOARD_SEARCH_DATED, {
            accesstype: getAccessType(role),
            actionlocation: type,
            boardid
        });
    } else {
        edap.trigger(named.TRIP_BOARD_SEARCH, {
            accesstype: getAccessType(role),
            actionlocation: type,
            boardid
        });
    }
};

named.heartClicked = function heartingClicked(boardid, actionstate) {
    edap.trigger(named.HEARTING_CLICK, {
        boardid,
        actionstate
    });
};

const TripboardEdapTrigger = {
    activityIndicator: generic.activityIndicator,
    activityIndicatorTooltip: generic.activityIndicatorTooltip,
    activitySeen: generic.activitySeen,
    deleteStart: generic.deleteStart,
    deleteCancel: generic.deleteCancel,
    deleteAttempt: function deleteAttempt(boardId) {
        generic.deleteAttempt(boardId);
        named.delete(boardId);
    },
    editStart: generic.editStart,
    editCancel: generic.editCancel,
    editDone: generic.editDone,
    boardClick(boardId, position, total) {
        generic.boardClick(boardId, position, total);
        named.click(boardId, ENTITY_TYPE.BOARD, boardId);
    },
    editAttempt(boardId, from, to, role) {
        generic.editAttempt(boardId, from, to);
        named.update(boardId, ENTITY_TYPE.BOARD, to, role);
    },
    listingClick(boardId, listingId, position, total) {
        generic.listingClick(boardId, listingId, position, total);
        named.click(boardId, ENTITY_TYPE.LISTING, listingId);
    },
    listingDelete(boardId, listingId, position, total, role) {
        generic.listingDelete(boardId, listingId, position, total);
        named.remove(boardId, ENTITY_TYPE.LISTING, listingId, role);
    },
    tripboardSearch(boardId, role, dated, type) {
        named.search(boardId, role, dated, type);
    },

    tripboardCreate(boardId) {
        named.create(boardId);
    },
    boardCreate: generic.boardCreate,
    boardCreateClick: generic.boardCreateClick,
    boardCreateSkip: generic.boardCreateSkip,
    boardCreateError: generic.boardCreateError,
    boardSaved: generic.boardSaved,

    tripboardLogin: generic.tripboardLogin,
    tripboardSignup: generic.tripboardSignup,

    detailsLoad: generic.detailsLoad,
    learnMoreClick: generic.learnMoreClick,
    tripboardsView: named.view,
    summariesLoad: generic.summariesLoad,
    copyClick: generic.copyClick,
    shareClick: generic.shareClick,
    heartClicked: named.heartClicked,
    copyUrl: generic.copyUrl,
    cutUrl: generic.cutUrl,
    datesClick: generic.datesClick,
    datesChange: generic.datesChange,
    invalidInviteModalPop: generic.invalidInviteModalPop,
    invalidInviteModalClose: generic.invalidInviteModalClose,
    listingDeleteModalOpen: generic.listingDeleteModalOpen,
    listingDeleteModalClose: generic.listingDeleteModalClose,
    carouselHitArrowClick: generic.carouselHitArrowClick,
    carouselCommentsArrowClick: generic.carouselCommentsArrowClick,
    carouselHitClick: generic.carouselHitClick,
    guestsClick: generic.guestsClick,
    guestsChange: generic.guestsChange,
    viewProperty: generic.viewProperty,
    placesError: generic.placesError,
    mapInteraction: generic.mapInteraction,
    mapMarkerClicked: generic.mapMarkerClicked,
    mapPropertyClicked: generic.mapPropertyClicked,
    mapTabClicked: generic.mapTabClicked
};

// Abacus: ha_pulse_shared_tripboard_ab_test
// Triggered from the tripboard-details copmonent.
export const evalAndLogSharedTripBoard = function logSharedTripBoard() {
    AbacusClientUtils.evaluateExperimentAndLog(HA_PULSE_SHARED_TRIPBOARD_AB_TEST);
};

export default TripboardEdapTrigger;



// WEBPACK FOOTER //
// ./src/universal/tripboard/edap.js